<script>
  let { value, skeleton = false } = $props();

  // Format date for display
  const formatDate = (timestamp) =>
    timestamp ? new Date(timestamp * 1000).toLocaleDateString() : "Unknown";
</script>

{#if skeleton}
  <span class:skeleton>Loading...</span>
{:else}
  <div>
    {formatDate(value)}
  </div>
{/if}
